import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import store from '@/store'
import {
  getCookie
} from '@/tools'
import {
  updateCheck
} from '@/utils/updateCheck.js'

//解决路由跳转报错问题(虽然此问题不影响使用 但是我看着不舒服)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//解决路由跳转报错问题(虽然此问题不影响使用 但是我看着不舒服) by 万世雄


/**
 *@description: 页面按需加载
 *@author zhang-shu-wei
 *@date 2022-10-27 16:06:21
*/
const OrderManager = () => import('@/components/ordermanager/order-manager')                              // 订单管理
const AfsOrderManager = () => import('@/components/afsOrderManager/afs-order-manager')                    // 售后单管理
const JxGoodsManager = () => import('@/components/goodmanager/jx-goods-manager')                          // 京西商品管理
const JxCatManager = () => import('@/components/goodmanager/goodAndCatManager/jx-cat-manager')            // 京西类目管理
const SortManager = () => import('@/components/goodmanager/goodAndCatManager/sort-manager')               // 商品排序
const ExdCatManager = () => import('@/components/goodmanager/goodAndCatManager/Exd-cat-manager')          // 饿鲜达商品管理
const BestSeller = () => import('@/components/goodmanager/bestSeller/bestSeller')                         // 畅销品查询


const JdCatManager = () => import('@/components/goodmanager/jdCatManager/jd-cat-manager')                 // 京东分类管理
const mtCatToJdManager = () => import('@/components/goodmanager/mtCatToJdManager/mtCat-to-jd-Manager')    // 美团分类映射到京东
const StoreCatManager = () => import('@/components/goodmanager/store-cat-manager')                        // 京西分类管理
const Goodswatermarkprev = () => import('@/components/goodmanager/goods-watermark-prev')                  // 商品水印前缀管理
const StoreGoodsManager = () => import('@/components/storegoodsmanager/store-goods-manager')              // 门店商品管理
// import JxStoreManager from '@/components/storemanager/jx-store-manager'                                // 门店管理
const BadReviewmanager = () => import('@/components/badReviewmanager/bad-review-manager')                 // 差评管理
const SendMessages = () => import('@/components/storemanager/send-messages')                              // 发送消息
const MessageDetail = () => import('@/components/storemanager/message-detail')                            // 消息详情
// import PromotionManager from '@/components/promotion/promotion-manager'                                // 促销活动管理
// import PromotionCreate from '@/components/promotion/promotion-create'                                  // 促销活动创建

const TaskManager = () => import('@/pages/system/taskManager')                                            // 系统管理-任务查询
const SystemConfig = () => import('@/pages/system/systemConfig')                                          // 系统管理-系统配置  
const VersionControl = () => import('@/pages/system/versionControl/index')                                // 系统管理-版本控制 
const SystemLog = () => import('@/pages/system/system-log')                                               // 系统管理-系统日志 
const CityConfig = () => import('@/pages/system/cityConfig')                                              // 系统管理-城市管理
const SystemTool = () => import('@/components/system/systemTool/system-tool.vue')                         // 系统管理-系统工具

const JDSettlement = () => import('@/components/finance/jd-settlement')                                   // 财务-京东结算
const StoreGoodsCheck = () => import('@/components/storegoodscheck/store-goods-check')                    // 门店商品价格审核
const SyncCats = () => import('@/components/smalltools/sync-cats')                                        // 同步饿百美团分类
const SyncJDSkunames = () => import('@/components/smalltools/sync-jdskunames')                            // 同步京东商品库
// const SystemTool = () => import('@/components/system/system-tool')                                        // 补全转送门店达达

const SyncJDGoods = () => import('@/components/system/sync-jd-goods')                                     // 京东商家商品状态同步
const SearchAllStores = () => import('@/components/system/search-all-stores')                             // 查询平台所有门店信息
const BatuploadStoreInfo = () => import('@/components/storemanager/bat-upload-storeinfo')                 // 批量导入门店信息
const BatStoreGood = () => import('@/components/smalltools/bat-store-good')

const ElectronicFence = () => import('@/components/ddManager/electronicFence/index.vue')                  // 批量设置电子围栏
const FreightTemplate = () => import('@/components/ddManager/freightTemplate/index.vue')                  // 批量设置运费模板
const SetRiderInfo = () => import('@/components/ddManager/setRiderInfo/index.vue')                        // 批量查询与配置门店运力
const CreateDDWarehouse = () => import('@/components/ddManager/setDdWareHouse/index.vue')                 // 批量创建抖店仓库
const TelephoneBill = () => import('@/components/monkeyManager/telephoneBill/index.vue')                  // 话费充值记录

// 新版活动
const NewPromotionCreate = () => import('@/components/promotion/new-promotion-create')
const NewPromotionManager = () => import('@/components/promotion/new-promotion-manager')
//平台活动
const ElmPromotion = () => import('@/components/promotion/plate-promotion/elm-promotion')
const MtPromotion = () => import('@/components/promotion/plate-promotion/mt-promotion')
const PromotionDetail = () => import('@/components/promotion/plate-promotion/promotion-detail')
const MtPromotionDetail = () => import('@/components/promotion/plate-promotion/mt-promotion-detail')
const UserRoleManager = () => import('@/components/system/user-role-manager/user-role-manager.vue')       // 用户角色管理
const MenuManager = () => import('@/components/PermissionManager/menuManager/menu-manager.vue')           //菜单管理

//角色管理
// import UserRoleManager from '@/components/PermissionManager/userRolemanager/user-role-manager.vue'
// 权限管理
//品牌管理
const BrandManager = () => import('@/components/storemanager/brandManager/brand-manager.vue')
const OtherBrand = () => import('@/components/storemanager/brandManager/other-brand.vue')
const biddingInfo = () => import('@/components/storemanager/brandManager/biddingInfo.vue')
//平台账号管理
const PlateManager = () => import('@/components/storemanager/plateStoreAccountManager/plate-account-manager.vue')

//冲天猴相关
const ImportMTVIP = () => import('@/components/monkeyManager/MTvip/ImportMTVip.vue')
const TaskMonkeyManager = () => import('@/components/monkeyManager/taskManager/taskManager.vue')
const bannerManagerMK = () => import('@/components/monkeyManager/bannerManagerMK/bannerManagerMK.vue')
const CashBillManager = () => import('@/components/monkeyManager/CashBillManager/CashBillManager.vue')
const MonkeyUserManager = () => import('@/components/monkeyManager/monkeyUserManager/monkeyUserManager.vue')
const Paymanager = () => import('@/components/monkeyManager/paymanager/paymanager.vue')
const BusinessManager = () => import('@/components/monkeyManager/businessManager/businessManager.vue')
const cthSystemConfig = () => import('@/components/monkeyManager/systemManager/cth-system-config.vue')
const unionMission = () => import('@/components/monkeyManager/unionMission/union-mission.vue')
const unionOrderManager = () => import('@/components/monkeyManager/unionOrderManager/union-order-manager.vue')
const homeMenu = () => import('@/components/monkeyManager/homeMenu/homeMenu.vue')
const ExpressQuery = () => import('@/components/monkeyManager/ExpressQuery/ExpressQuery.vue')
const withdrawalList = () => import('@/components/monkeyManager/withdrawalList/withdrawalList.vue')
Vue.use(Router)

// 商城管理相关
const merchantMenu = () => import('@/pages/shop/merchantMenu/merchantMenu.vue')

// 按需加载
// 登录页面
const LoginPage = () => import('@/components/login/index')
// 主页
// const IndexPage = () => import('@/components/indexpage/indexpage3')
const IndexPage = () => import('@/pages/indexpage/indexpage3')
// 价格参考
const PriceReference = () => import('@/components/priceReference/index')
// 初始化商品
const RegressGood = () => import('@/components/goodmanager/regress-good')
// 删除远程门店商品
const DeleteGood = () => import('@/components/syncManager/delete-good')
// 删除平台有京西没有
const SyncDeleteGoods = () => import('@/components/syncManager/sync-delete-goods')
const SyncMTEBGoods = () => import('@/components/syncManager/sync-mteb-goods')
/* ---------订单管理--------- */
// 订单管理
// const OrderManager = () => import('@/components/ordermanager/order-manager')
// 订单召唤美团专送
const ToolOrderCallMT = () => import('@/components/smalltools/tool-order-call-mt')

/* ---------商品管理--------- */
// 京西商品管理
// const JxGoodsManager = () => import('@/components/goodmanager/jx-goods-manager')
// 门店商品管理
// const StoreGoodsManager = () => import('@/components/storegoodsmanager/store-goods-manager')
// 小工具-京西门店商品复制到京西门店
const ToolJXGoodsToJX = () => import('@/components/smalltools/tool-jxgoods-tojx')
// 京西门店商品同步到远端
const ToolJXGoodsToPlatform = () => import('@/components/smalltools/tool-jxgoods-toplatform')
// 小工具-京东门店商品复制到京东门店
// const ToolJDGoodsToJD = () => import('@/components/smalltools/tool-jdgoods-tojd')
// 小工具-京西门店商品复制到饿了么门店
// const ToolJXGoodsToELM = () => import('@/components/smalltools/tool-jxgoods-toelm')
// 小工具-门店商品集体下架
const ToolStoreGoodsOff = () => import('@/components/smalltools/tool-storegoods-off')
// 小工具-刷新京东门店商品库存可售
// const ToolRefreshJDGoodsSale = () => import('@/components/smalltools/tool-refreshjd-goodssale')

// 小工具-多门店多商品关注可售改价
const ToolStoresPriceFOcusSale = () => import('@/components/smalltools/tool-stores-pricefocussale')

// 将为份的商品在京东转成SPU
const Convert2JDSPU = () => import('@/components/temporary/convert-JDSPU')

// 测试页面
const Test01 = () => import('@/components/temporary/test01')
const Test02 = () => import('@/components/temporary/test02')

/* ---------门店管理--------- */
// 京西门店管理
const JxStoreManager = () => import('@/components/storemanager/jx-store-manager')
const searchStore = () => import('@/components/storemanager/search-store')
// 创建门店
// const CreateStore = () => import('@/components/storemanager/create-store.vue')
// 小工具-分组管理
// const ToolGroupManager = () => import('@/components/smalltools/tool-group-manager')
// 小工具-删除京西门店
// const ToolDeleteJXStore = () => import('@/components/smalltools/tool-delete-jxstore')

/* ---------财务--------- */
// 导出美团专送订单
// const ToolExportMTOrder = () => import('@/components/finance/tool-exportmt-order')
// 导出订单
// const ToolExportOrder = () => import('@/components/finance/tool-export-order')
// 门店账单推送
const StoreExcelSend = () => import('@/components/finance/store-excel-send')

/* ---------活动--------- */
// 创建活动
// const PromotionManager = () => import('@/components/promotion/promotion-manager')



// 上传图片
const UploadImg = () => import('@/components/temporary/tem-upload-img.vue')
//每日一词
const Daydayknowladge = () => import('@/components/temporary/daydayknowladge.vue')
const DayEditTemplete = () => import('@/components/temporary/editTemplete.vue')

// 菜谱
const CookBook = () => import('@/components/cookbook/cookbook-manager')
const StoreCheck = () => import('@/components/storecheck/store-check')

const router = new Router({
  routes: [{
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: ''
    },
    children: [
      {
        path: 'test01',
        name: 'test01',
        component: Test01,
        meta: {
          title: '测试页面'
        }
      },
      {
        path: 'test02',
        name: 'test02',
        component: Test02,
        meta: {
          title: '测试页面'
        }
      },
      {
        path: 'test03',
        name: 'test03',
        component: () => import('@/components/temporary/test03.vue'),
        meta: {
          title: '测试页面3'
        }
      },
      {
        path: 'indexpage',
        name: 'IndexPage',
        component: IndexPage,
        meta: {
          title: ''
        }
      },
      {
        path: 'priceReference',
        name: 'priceReference',
        component: PriceReference,
        meta: {
          title: '价格参考'
        }
      },
      {
        path: 'regressGood',
        name: 'regressGood',
        component: RegressGood,
        meta: {
          title: '初始化门店商品'
        }
      },
      {
        path: 'deleteGood',
        name: 'deleteGood',
        component: DeleteGood,
        meta: {
          title: '删除远程门店商品'
        }
      },
      {
        path: 'toolordercallmt',
        name: 'ToolOrderCallMT',
        component: ToolOrderCallMT,
        meta: {
          title: '订单召唤美团专送'
        }
      },
      {
        path: 'jxstoremanager',
        name: 'JxStoreManager',
        component: JxStoreManager,
        meta: {
          title: '京西门店管理'
        }
      },
      {
        path: 'brandManager',
        name: 'brandManager',
        component: BrandManager,
        meta: {
          title: '品牌管理'
        }
      },
      {
        path: 'otherBrand',
        name: 'otherBrand',
        component: OtherBrand,
        meta: {
          title: '三方电话'
        }
      },
      {
        path: 'biddingInfo',
        name: 'biddingInfo',
        component: biddingInfo,
        meta: {
          title: '招标信息'
        }
      },
      {
        path: 'plateManager',
        name: 'plateManager',
        component: PlateManager,
        meta: {
          title: '品牌管理'
        }
      },
      {
        path: 'storerank',
        name: 'StoreRank',
        component: () => import('@/components/storemanager/store-rank.vue'),
        meta: {
          title: '门店评分'
        }
      },
      {
        path: 'ddStoreManager/electronicFence',
        name: 'electronicFence',
        component: ElectronicFence,
        meta: {
          title: '批量设置电子围栏'
        }
      },
      {
        path: 'ddStoreManager/freightTemplate',
        name: 'freightTemplate',
        component: FreightTemplate,
        meta: {
          title: '批量设置运费模板'
        }
      },
      {
        path: 'ddStoreManager/setRiderInfo',
        name: 'setRiderInfo',
        component: SetRiderInfo,
        meta: {
          title: '批量查询与配置门店运力'
        }
      },
      {
        path: 'ddStoreManager/setDdWarehouse',
        name: 'setDdWarehouse',
        component: CreateDDWarehouse,
        meta: {
          title: '创建抖店仓库'
        }
      },
      {
        path: 'storeCheck',
        name: 'storeCheck',
        component: StoreCheck,
        meta: {
          title: '门店审核'
        }
      },
      {
        path: 'searchstore',
        name: 'searchstore',
        component: searchStore,
        meta: {
          title: '门店查询'
        }
      },
      {
        path: 'storepricerank',
        name: 'StorePriceRank',
        component: () => import('@/components/storemanager/store-price-rank.vue'),
        meta: {
          title: '门店价格评分'
        }
      },
      {
        path: 'batuploadstoreinfo',
        name: 'BatuploadStoreInfo',
        component: BatuploadStoreInfo,
        meta: {
          title: '批量导入门店信息'
        }
      },
      {
        path: 'sendMessages',
        name: 'SendMessages',
        component: SendMessages,
        meta: {
          title: '发送消息'
        }
      },
      {
        path: 'badReviewmanager',
        name: 'BadReviewmanager',
        component: BadReviewmanager,
        meta: {
          title: '差评管理'
        }
      },
      {
        path: 'messageDetail',
        name: 'MessageDetail',
        component: MessageDetail,
        meta: {
          title: '消息详情'
        }
      },
      {
        path: 'jxgoodsmanager',
        name: 'JxGoodsManager',
        component: JxGoodsManager,
        meta: {
          title: '京西商品管理'
        }
      },
      {
        path: 'jxCatManager',
        name: 'jxCatManager',
        component: JxCatManager,
        meta: {
          title: '京西类目管理'
        }
      },
      {
        path: 'sortManager',
        name: 'sortManager',
        component: SortManager,
        meta: {
          title: '商品排序'
        }
      },
      {
        path: 'exdCatManager',
        name: 'exdCatManager',
        component: ExdCatManager,
        meta: {
          title: '饿鲜达分类管理'
        }
      },
      // BestSeller
      {
        path: 'bestSeller',
        name: 'bestSeller',
        component: BestSeller,
        meta: {
          title: '畅销品查询'
        }
      },
      {
        path: 'jdCatManager',
        name: 'jdCatManager',
        component: JdCatManager,
        meta: {
          title: '京东分类管理'
        }
      },
      {
        path: 'mtcattoJdmanager',
        name: 'MtCatToJdManager',
        component: mtCatToJdManager,
        meta: {
          title: '美团分类映射京东分类'
        }
      },
      {
        path: 'storecatmanager',
        name: 'storecatmanager',
        component: StoreCatManager,
        meta: {
          title: '商品分类管理'
        }
      },
      {
        path: 'goodswatermarkprev',
        name: 'goodswatermarkprev',
        component: Goodswatermarkprev,
        meta: {
          title: '商品水印前缀管理'
        }
      },
      {
        path: 'storegoodsmanager',
        name: 'StoreGoodsManager',
        component: StoreGoodsManager,
        meta: {
          title: '门店商品管理'
        }
      },
      {
        path: 'StoreGoodsCheck',
        name: 'StoreGoodsCheck',
        component: StoreGoodsCheck,
        meta: {
          title: '门店商品修改审核'
        }
      },
      {
        path: 'systemtool',
        name: 'SystemTool',
        component: SystemTool,
        meta: {
          title: '系统工具'
        }
      },
      {
        path: 'syncjdgoods',
        name: 'SyncJDGoods',
        component: SyncJDGoods,
        meta: {
          title: '京东商家商品状态同步'
        }
      },
      {
        path: 'tooljxgoodstojx',
        name: 'ToolJXGoodsToJX',
        component: ToolJXGoodsToJX,
        meta: {
          title: '京西门店商品复制到京西'
        }
      },
      {
        path: 'tooljxgoodstoplatform',
        name: 'ToolJXGoodsToPlatform',
        component: ToolJXGoodsToPlatform,
        meta: {
          title: '京西门店商品同步到平台'
        }
      },
      {
        path: 'synccats',
        name: 'SyncCats',
        component: SyncCats,
        meta: {
          title: '同步美团饿百分类'
        }
      },
      {
        path: 'syncjdskunames',
        name: 'SyncJDSkunames',
        component: SyncJDSkunames,
        meta: {
          title: '维护京东商品库'
        }
      },
      // {
      //   path: 'tooljdgoodstojd',
      //   name: 'ToolJDGoodsToJD',
      //   component: ToolJDGoodsToJD,
      //   meta: {
      //     title: '小工具-京东门店商品复制到京东门店'
      //   }
      // },
      // {
      //   path: 'tooljxgoodstoelm',
      //   name: 'ToolJXGoodsToELM',
      //   component: ToolJXGoodsToELM,
      //   meta: {
      //     title: '小工具-京西门店商品复制到饿了么门店'
      //   }
      // },
      {
        path: 'toolstoregoodsoff',
        name: 'ToolStoreGoodsOff',
        component: ToolStoreGoodsOff,
        meta: {
          title: '门店商品可售状态修改'
        }
      },
      {
        path: 'syncdeletegoods',
        name: 'SyncDeleteGoods',
        component: SyncDeleteGoods,
        meta: {
          title: '删除平台有京西没有的商品'
        }
      },
      {
        path: 'syncamtebgoods',
        name: 'SyncMTEBGoods',
        component: SyncMTEBGoods,
        meta: {
          title: '维护美团饿百商品'
        }
      },
      {
        path: 'syncstore',
        name: 'SyncStore',
        component: () => import('@/pages/sync/sync-store'),
        meta: {
          title: '同步平台门店'
        }
      },
      {
        path: 'syncjggoods',
        name: 'syncjggoods',
        component: () => import('@/pages/sync/sync-jg-goods'),
        meta: {
          title: '同步京狗商品库存'
        }
      },
      // {
      //   path: 'toolgroupmanager',
      //   name: 'ToolGroupManager',
      //   component: ToolGroupManager,
      //   meta: {
      //     title: '分组管理'
      //   }
      // },
      // {
      //   path: 'tooldeletejxstore',
      //   name: 'ToolDeleteJXStore',
      //   component: ToolDeleteJXStore,
      //   meta: {
      //     title: '小工具-删除京西门店'
      //   }
      // },
      {
        path: 'storeexcelsend',
        name: 'StoreExcelSend',
        component: StoreExcelSend,
        meta: {
          title: '门店账单推送'
        }
      },
      {
        path: 'supplement',
        name: 'Supplement',
        component: () => import('@/pages/financial/supplement'),
        meta: {
          title: '扣款冲账管理'
        }
      },
      {
        path: 'systemlog',
        name: 'SystemLog',
        // component: () => import('@/pages/system/system-log'),
        component: SystemLog,
        meta: {
          title: '系统日志'
        }
      },
      // {
      //   path: 'toolexportorder',
      //   name: 'ToolExportOrder',
      //   component: ToolExportOrder,
      //   meta: {
      //     title: '导出平台订单'
      //   }
      // },
      // {
      //   path: 'toolexportmtorder',
      //   name: 'ToolExportMTOrder',
      //   component: ToolExportMTOrder,
      //   meta: {
      //     title: '导出美团专送订单'
      //   }
      // },
      {
        path: 'ordermanager',
        name: 'OrderManager',
        component: OrderManager,
        meta: {
          title: '订单管理'
        }
      },
      {
        path: 'ordermanager/:id',
        name: 'OrderManagerDetail',
        component: () => import('@/components/ordermanager/order-detail'),
        meta: {
          title: '订单管理详情'
        }
      },
      // {
      //   path: 'promotionmanager',
      //   name: 'PromotionManager',
      //   component: PromotionManager,
      //   meta: {
      //     title: '促销活动管理'
      //   }
      // },
      // {
      //   path: 'promotioncreate',
      //   name: 'PromotionCreate',
      //   component: PromotionCreate,
      //   meta: {
      //     title: '促销活动创建'
      //   }
      // },
      {
        path: 'newpromotioncreate',
        name: 'NewPromotionCreate',
        component: NewPromotionCreate,
        meta: {
          title: '活动创建'
        }
      },
      {
        path: 'newpromotioncreate/:id',
        name: 'NewPromotionCreate2',
        component: NewPromotionCreate,
        meta: {
          title: '活动创建'
        }
      },
      {
        path: 'newpromotionmanager',
        name: 'NewPromotionManager',
        component: NewPromotionManager,
        meta: {
          title: '活动管理'
        }
      },
      {
        path: 'elmpromotion',
        name: 'ElmPromotion',
        component: ElmPromotion,
        meta: {
          title: '饿百活动信息'
        }
      },
      {
        path: 'mtpromotion',
        name: 'MtPromotion',
        component: MtPromotion,
        meta: {
          title: '美团活动信息'
        }
      },
      {
        path: 'promotiondetail/:id',
        name: 'PromotionDetail',
        component: PromotionDetail,
        meta: {
          title: '活动详情'
        }
      },
      {
        path: 'mtpromotiondetail/:id/:store',
        name: 'MtPromotionDetail',
        component: MtPromotionDetail,
        meta: {
          title: '活动详情'
        }
      },
      {
        path: 'uploadexcel',
        name: 'UploadExcel',
        component: () => import('@/components/smalltools/uploadExcel.vue'),
        meta: {
          title: '导入excel'
        }
      },
      {
        path: 'taskmanager',
        name: 'TaskManager',
        component: TaskManager,
        meta: {
          title: '任务查询'
        }
      },
      {
        path: 'jdsettlement',
        name: 'JDSettlement',
        component: JDSettlement,
        meta: {
          title: '京东结算'
        }
      },
      {
        path: 'toolstorespricefocussale',
        name: 'ToolStoresPriceFOcusSale',
        component: ToolStoresPriceFOcusSale,
        meta: {
          title: '京西批量关注可售改价'
        }
      },
      {
        path: 'batstoregood',
        name: 'BatStoreGood',
        component: BatStoreGood,
        meta: {
          title: '单门店单商品批量修改'
        }
      },
      {
        path: 'Convert2JDSPU',
        name: 'Convert2JDSPU',
        component: Convert2JDSPU,
        meta: {
          title: '将为份的商品在京东转成SPU'
        }
      },
      {
        path: 'systemconfig',
        name: 'SystemConfig',
        component: SystemConfig,
        meta: {
          title: '系统配置'
        }
      },
      {
        path: 'versionControl',
        name: 'VersionControl',
        component: VersionControl,
        meta: {
          title: '版本控制'
        }
      },
      {
        path: 'cityconfig',
        name: 'CityConfig',
        component: CityConfig,
        meta: {
          title: '城市管理'
        }
      },
      {
        path: 'batuploadMTVIPinfo',
        name: 'BatuploadMTVIPinfo',
        component: ImportMTVIP,
        meta: {
          title: '批量导入美团会员'
        }
      },
      {
        path: 'taskMonkeyManager',
        name: 'taskMonkeyManager',
        component: TaskMonkeyManager,
        meta: {
          title: '任务管理'
        }
      },
      {
        path: 'paymanager',
        name: 'paymanager',
        component: Paymanager,
        meta: {
          title: '支付分析'
        }
      },

      {
        path: 'businessManager',
        name: 'businessManager',
        component: BusinessManager,
        meta: {
          title: '支付分析'
        }
      },
      {
        path: 'cthsystemconfig',
        name: 'CthSystemConfig',
        component: cthSystemConfig,
        meta: {
          title: '系统配置'
        }
      },
      {
        path: 'unionmission',
        name: 'unionMission',
        component: unionMission,
        meta: {
          title: '联盟任务'
        }
      },
      {
        path: 'unionordermanager',
        name: 'unionordermanager',
        component: unionOrderManager,
        meta: {
          title: '联盟订单管理'
        }
      },
      {
        path: 'cashBillManager',
        name: 'cashBillManager',
        component: CashBillManager,
        meta: {
          title: '提现账单管理'
        }
      },

      {
        path: 'monkeyUserManager',
        name: 'monkeyUserManager',
        component: MonkeyUserManager,
        meta: {
          title: '用户管理'
        }
      },
      {
        path: 'bannerManagerMK',
        name: 'bannerManagerMK',
        component: bannerManagerMK,
        meta: {
          title: '首页banner配置'
        }
      },
      {
        path: 'homeMenu',
        name: 'homeMenu',
        component: homeMenu,
        meta: {
          title: '首页菜单设置'
        }
      },
      {
        path: 'ExpressQuery',
        name: 'ExpressQuery',
        component: ExpressQuery,
        meta: {
          title: '快递查询'
        }
      },
      {
        path: 'telephoneBill',
        name: 'telephoneBill',
        component: TelephoneBill,
        meta: {
          title: '话费充值记录'
        }
      },
      {
        path: 'withdrawalList',
        name: 'withdrawalList',
        component: withdrawalList,
        meta: {
          title: '用户申请体现'
        }
      },
      {
        path: 'afsordermanager',
        name: 'AfsOrderManager',
        component: AfsOrderManager,
        meta: {
          title: '售后单管理'
        }
      },
      {
        path: 'searchallstores',
        name: 'SearchAllStores',
        component: SearchAllStores,
        meta: {
          title: '查询平台所有门店信息'
        }
      },
      {
        path: 'userrolemanager',
        name: 'UserRoleManager',
        component: UserRoleManager,
        meta: {
          title: '用户角色管理'
        }
      },
      {
        path: 'menumanager',
        name: 'menumanager',
        component: MenuManager,
        meta: {
          title: '菜单管理'
        }
      },
      {
        path: 'userRoleManager',
        name: 'userRoleManager',
        component: UserRoleManager,
        meta: {
          title: '角色管理'
        }
      },
      {
        path: 'afsordermanager/:id',
        name: 'AfsOrderDetail',
        component: () => import('@/components/afsOrderManager/afs-order-detail'),
        meta: {
          title: '售后单详情'
        }
      },
      {
        path: 'daydayknowladge',
        name: 'daydayknowladge',
        component: Daydayknowladge,
        meta: {
          title: '每日一词'
        }
      },
      {
        path: 'editTemplete',
        name: 'DayEditTemplete',
        component: DayEditTemplete,
        meta: {
          title: '每日一词'
        }
      },
      {
        path: 'uploadimg',
        name: 'UploadImg',
        component: UploadImg,
        meta: {
          title: '上传图片'
        }
      },
      {
        path: 'uploadyonghuiexcel',
        name: 'UploadYHExcel',
        component: () => import('@/components/temporary/upload-yonghui-excel.vue'),
        meta: {
          title: '微盟直营店相关'
        }
      },
      {
        path: 'cookbook',
        name: 'CookBook',
        component: CookBook,
        meta: {
          title: '菜谱管理'
        }
      },
      {
        path: 'cookbookdetail',
        name: 'CookBookDetail',
        component: () => import('@/components/cookbook/cookbook-detail'),
        meta: {
          title: '菜谱编辑创建'
        }
      },
      {
        path: 'cookbook/:id',
        name: 'CookBookDetail',
        component: () => import('@/components/cookbook/cookbook-detail'),
        meta: {
          title: '菜谱编辑创建'
        }
      },
      {
        path: 'reportfororder',
        name: 'ReportForOrder',
        component: () => import('@/pages/report/report-order/index.vue'),
        meta: {
          title: '统计门店营业数据'
        }
      },
      {
        path: 'storegoodssalesinfo',
        name: 'StoreGoodsSalesInfo',
        component: () => import('@/pages/report/report-store-goods-info/index.vue'),
        meta: {
          title: '商家商品销量统计'
        }
      },
      {
        path: 'reportuser',
        name: 'ReportUser',
        component: () => import('@/pages/report/report-user/index.vue'),
        meta: {
          title: '商城用户信息统计'
        }
      },
      {
        path: 'reportvipuser',
        name: 'ReportVipUser',
        component: () => import('@/pages/report/report-vip-user/index.vue'),
        meta: {
          title: '会员信息统计'
        }
      },
      {
        path: 'reportbusiness',
        name: 'reportbusiness',
        component: () => import('@/pages/report/report-business/index.vue'),
        meta: {
          title: '营业数据统计'
        }
      },
      {
        path: 'tmp1',
        name: 'tmp1',
        component: () => import('@/components/temporary/tmp1.vue'),
        meta: {
          title: '老格恢复拓店进度'
        }
      },
      {
        path: 'reportskus',
        name: 'reportskus',
        component: () => import('@/pages/report/report-skus/index.vue'),
        meta: {
          title: '京西商品价格统计'
        }
      },
      {
        path: 'batbindjxvendorstore',
        name: 'batbindjxvendorstore',
        component: () => import('@/components/storemanager/bat-bind-jxvendorstore.vue'),
        meta: {
          title: '京西商品价格统计'
        }
      },
      {
        path: '/about',
        name: 'AboutPage',
        component: () => import('@/pages/about/index.vue'),
        meta: {
          title: '关于'
        }
      },
      {
        path: '/searchrecommend',
        name: 'Searchrecommend',
        component: () => import('@/pages/storeGoods/search-recommend/index.vue'),
        meta: {
          title: '根据城市查询推荐商品'
        }
      },
      {
        path: '/addmtgoodstag',
        name: 'MtAddGoodsTag',
        component: () => import('@/pages/sync/mt-addgoods-tag/index.vue'),
        meta: {
          title: '美团力荐设置'
        }
      },
      {
        path: '/banner-manager',
        name: 'BannerManager',
        component: () => import('@/pages/shop/banner-manager'),
        meta: {
          title: '商城banner管理'
        }
      },
      {
        path: '/store-banner-manager',
        name: 'StoreBannerManager',
        component: () => import('@/pages/shop/store-banner-manager'),
        meta: {
          title: '门店banner管理'
        }
      },
      {
        path: '/merchantMenu',
        name: 'merchantMenu',
        component: merchantMenu,
        meta: {
          title: '商城首页菜单设置'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/notfound',
    component: () => import('@/components/notfound')
  },
  {
    path: '*',
    component: () => import('@/components/notfound')
  }
  ]
})


/**
 * 前置路由守卫
 */
router.beforeEach((to, from, next) => {
  // 强行把http协议转成https
  if (process.env.NODE_ENV != "development") {
    let olderHerf = window.location.protocol
    let targetProtocol = "https:"
    if (olderHerf != targetProtocol) {
      window.location.href = targetProtocol + window.location.href.substring(window.location.protocol.length);
    }
  }

  // 检查新版本
  updateCheck()
  // 获取Token
  if (getCookie('Token')) {
    // 获取到token
    // 判断是否有用户信息
    if (!store.getters.userInfo) {
      // user为空
      store.dispatch('GetUserInfo').then(res => {
        next()
      }).catch(err => {
        next('/login')
        return false
      })
    } else {
      // 有user信息
      if (to.path === '/login') {
        next({
          path: from.path
        })
        return false
      } else {
        next()
      }
    }
  } else {
    // 未获取到Token
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
      return
    }
  }

  if (to.path === '/') {
    next({
      name: 'IndexPage',
      replace: true
    })
  }
  //
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js